import { useUrlChecker } from '@/hooks/useUrlChecker';

import { useUserQuery } from './user-query';

export const useUser = () => {
  const { isPublic } = useUrlChecker();
  const { data: user } = useUserQuery({ enabled: !isPublic });

  return { isPublic, user };
};
